import { notifySuccess } from 'Portainer/services/notifications';
import { EdgeUpdateListItemResponse } from '@/react/portainer/environments/update-schedules/queries/list';
import { EdgeUpdateSchedule } from '@/react/portainer/environments/update-schedules/types';

import { DeleteButton } from '@@/buttons/DeleteButton';

import { useRemoveMutation } from '../../queries/useRemoveMutation';

export function DeleteScheduleButton({
  schedule,
  disabled,
}: {
  schedule: EdgeUpdateListItemResponse;
  disabled: boolean;
}) {
  const removeMutation = useRemoveMutation();

  return (
    <DeleteButton
      disabled={disabled}
      onConfirmed={() => handleRemove(schedule)}
      text=""
      confirmMessage="Are you sure you want to remove the selected schedule?"
      data-cy="remove-update-schedules-button"
      icon
      size="medium"
    />
  );

  async function handleRemove(schedule: EdgeUpdateSchedule) {
    removeMutation.mutate([schedule], {
      onSuccess: () => {
        notifySuccess('Success', 'Schedule removed');
      },
    });
  }
}
